import type { JSX } from 'react';

import { Box, Container } from '@change-corgi/design-system-legacy/layout';

import { useStepState } from 'src/app/pages/startAPetition/pageContext';

export function StepProgressBar(): JSX.Element {
	const { data } = useStepState();
	const completed = ((data.metadata.currentStepIndex + 1) / data.totalNumberOfSteps) * 100;

	return (
		<Container px={0}>
			<Box sx={{ height: 8, backgroundColor: 'sunrise.semantic.fill.inverse.weak', overflow: 'hidden' }}>
				<Box sx={{ width: `${completed}%`, height: '100%', background: 'sunrise.gradient.fill.progress' }} />
			</Box>
			{/*
				TODO: https://change.atlassian.net/browse/CHANGE-63376
				Update the progressbar labelling to handle "subflow" step calculation
				Some steps have steps their own "subflow" which causes the "current" and "max"
				values to be incorrect.
			*/}
			{/* <VisuallyHidden>
				<label htmlFor="progress">
					{translate('corgi.sap.progress_bar.accessible_step', {
						thisStepNumber: (data.metadata.currentStepIndex + 1).toString(),
						totalNumberOfSteps: data.totalNumberOfSteps.toString(),
					})}
				</label>
				<progress
					data-testid="accessible-progress-bar"
					max={data.totalNumberOfSteps}
					value={data.metadata.currentStepIndex + 1}
				></progress>
			</VisuallyHidden> */}
		</Container>
	);
}
